import { indexData } from '@/mocks/home';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-folder-open-line"></i>
              内容导航
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              专题合集
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              按主题分类浏览，快速找到你感兴趣的吃瓜内容
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
            {indexData.map((item) => (
              <a
                key={item.id}
                href="#cards"
                className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-200 cursor-pointer"
              >
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center mb-3 ${
                    item.color === 'primary'
                      ? 'bg-primary-100 text-primary-600'
                      : 'bg-accent-100 text-accent-600'
                  }`}
                >
                  <i className={`${item.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2 line-clamp-1">
                  {item.description}
                </p>
                <span className="text-[10px] md:text-xs px-2 py-0.5 rounded-full bg-background-200 text-foreground-500 font-medium whitespace-nowrap">
                  {typeof item.count === 'number' ? `${item.count}篇` : item.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}